export default "__VITE_ASSET__vKl5kLd___"